<template>
  <Menu />
  <Zapis />
  <Phone />
  <div class="prin">
    <div class="cen">
            <div class="mr"></div>
            <h1>Правовая информация</h1>
            <div class="mr"></div>
            
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FВыписка%20из%20единого%20реестра%20лицензий.pdf&name=Выписка%20из%20единого%20реестра%20лицензий.pdf" target="_blank" rel="noopener">
                <h6>
                    Выписка из единого реестра лицензий
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FО%20возможности%20получения%20бесплатной%20медицинской%20помощи.docx&name=О%20возможности%20получения%20бесплатной%20медицинской%20помощи.docx&nosw=1" target="_blank" rel="noopener">
                <h6>
                    О возможности получения бесплатной медицинской помощи
                </h6>
            </a>
            <a href=" https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FО%20порядке%20и%20условиях%20предоставления%20медицинской%20помощи%20бесплатно%20на%20сайт.doc&name=О%20порядке%20и%20условиях%20предоставления%20медицинской%20помощи%20бесплатно%20на%20сайт.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    О порядке и условиях предоставления медицинской помощи бесплатно
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FОбразец%20договора%20на%20оказание%20платных%20медицинских%20услуг%20ДентаКор%20Плюс%20с%2001.09.2023.doc&name=Образец%20договора%20на%20оказание%20платных%20медицинских%20услуг%20ДентаКор%20Плюс%20с%2001.09.2023.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Образец договора на оказание платных медицинских услуг ДентаКор Плюс
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПриложение%20к%20договору%20Перечень%20медицинских%20услуг%20ДентаКор%20Плюс.doc&name=Приложение%20к%20договору%20Перечень%20медицинских%20услуг%20ДентаКор%20Плюс.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Приложение к договору Перечень медицинских услуг ДентаКор Плюс
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПрава%20и%20обязанности%20граждан%20в%20сфере%20охраны%20здоровья.doc&name=Права%20и%20обязанности%20граждан%20в%20сфере%20охраны%20здоровья.doc&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Права и обязанности граждан в сфере охраны здоровья
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПорядки%20оказания%20медицинской%20помощи.docx&name=Порядки%20оказания%20медицинской%20помощи.docx&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Порядки оказания медицинской помощи
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПравила_предоставление_платных_медицинских_услуг_Постановление_Правительства%20736.pdf&name=Правила_предоставление_платных_медицинских_услуг_Постановление_Правительства%20736.pdf&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Правила предоставления платных медицинских услуг - Постановление Правительства 736
                </h6>
            </a>
            <a href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FWK%2BKrTQVf1%2BskAT5sY%2FJ5a1G6RHpX1O2dwErASKkBBqoIPzj3uuPq3D%2F4vVD6cWoq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FСроки%20ожидания%20платных%20медицинских%20услуг.docx&name=Сроки%20ожидания%20платных%20медицинских%20услуг.docx&nosw=1" target="_blank" rel="noopener">
                <h6>
                    Сроки ожидания платных медицинских услуг
                </h6>
            </a>
            <a href="https://disk.yandex.ru/i/5acsA0fFnPqbUg" target="_blank" rel="noopener">
                <h6>
                    Перечень медицинских организаций, участвующих в реализации программы госгарантий
                </h6>
            </a>
            <a href="http://publication.pravo.gov.ru/document/0001202512240041" target="_blank" rel="noopener">
                <h6>
                    Распоряжение Правительства Российской Федерации от 18.12.2025 № 3867-р
                </h6>
            </a>
            <br>
            <br>
            <br>
            <h3>Органы контроля в сфере охраны здоровья граждан:</h3>
            <div class="mr"></div>
              <a href="https://roszdravnadzor.gov.ru/" target="_blank" rel="noopener">
                <h6>www.21reg.roszdravnadzor.ru</h6>
              </a>
              <p>
                Территориальный орган Росздравнадзора по Чувашской Республике
                <br>
                28018, Чувашская Республика – Чувашия, г.Чебоксары, Московский проспект, 36 <br>
                Телефон: +7 (8352) 58-28-17, <br>
                Факс: +7 (8352) 58-25-19 <br>
                E-mail: terorgan21@cbx.ru
              </p>
              <div class="mr"></div>
              <a href="https://21.rospotrebnadzor.ru" target="_blank" rel="noopener">
                <h6>www.21.rospotrebnadzor.ru</h6>
              </a>
              <p>
                Управление Федеральной службы по надзору в сфере защиты прав потребителей и благополучия человека по Чувашской Республики   
                <br>  
                428018, Чувашская Республика – Чувашия, г.Чебоксары, Московский проспект, 3Д <br>
                Телефон: +7 (8352) 58-17-13, <br>
                Факс: +7 (8352) 58-53-07 <br>
                E-mail: sanit@21.rospotrebnadzor.ru
              </p>
            <br>
            <br>
            <br>
            <h3>Рубрикатор клинических рекомендаций:</h3>
            <div class="mr"></div>
              <a href="https://cr.minzdrav.gov.ru/" target="_blank" rel="noopener">
                <h6>www.cr.minzdrav.gov.ru</h6>
              </a>
              
        </div>

    
    
  </div>
  <Map />
  <Foot />
</template>

<script>
import Menu from '@/components/Menu.vue'
import Zapis from '@/components/Zapis.vue'
import Phone from '@/components/Phone.vue'
import Map from '@/components/Map.vue'
import Foot from '@/components/Foot.vue'

export default {
  components: {
    Menu,
    Zapis,
    Phone,
    Map,
    Foot,
  }
}
</script>

<style scoped>

.mr {
  height: 5vh;
}

.prin {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-template-rows: repeat(3, 42vh);
  margin: 0 auto;
  width: 80vw;
  height: 250vh;
}

.bloc {
  background-color: #f5ee92;
  width: 25vw;
  height: 30vh;
  margin: 5vh auto;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 10vw;
  height: 10vw;
}

.sname {
  background-color: #363636;
  color: white;
  font-size: 1.5vw;
  width: 25vw;
  height: 8vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #363636; 
  transition: all 0.4s ease;
}

.sname:hover {
  background-color: white;
  color: black;
  transition: all 0.4s ease;
}

button {
  display: flex;
  width: 20vw;
  margin-left: 10vw;
  background: none;
  border: none;
  margin-bottom: 0;
  line-height: 1.5vw;
}

h1 {
  font-size: 3vw;
  margin-left: 5vw;
}

h6 {
  font-size: 1.7vw;
  cursor: pointer;
  transition: all 0.4s ease;
  margin-bottom: 5vh;
}

h6:hover {
  color: #bb8745;
  transition: all 0.4s ease;
}

@media (max-width: 790px) {

  .prin {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-template-rows: repeat(3, 42vh);
    height: 250vh;
  }

  .bloc {
    width: 80vw;
    height: 30vh;
    margin-top: 6vh;
  }

  img {
    width: 40vw;
    height: 40vw;
  }

  .sname {
    font-size: 20px;
    width: 80vw;
    height: 8vh;
    margin-top: 0;
    line-height: 21px;
  }

  h1 {
    font-size: 30px;
  }

  h6 {
    font-size: 16px;
  }

}

</style>

